import { Popover } from 'foundations-components/transitional/components/Popover';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AsyncSmartDataCaptureCitationPopoverContent = Loadable({
  loader: () => import('./SmartDataCaptureCitationPopoverContentContainer')
});
export const preloadSmartDataCaptureCitationPopover = async () => {
  await AsyncSmartDataCaptureCitationPopoverContent.preload();
};
export default function SmartDataCaptureCitationPopover({
  smartDataCaptureSuggestionId,
  httpClient,
  onOpenChange,
  open,
  children
}) {
  return /*#__PURE__*/_jsx(Popover, {
    content: /*#__PURE__*/_jsx(AsyncSmartDataCaptureCitationPopoverContent, {
      httpClient: httpClient,
      smartDataCaptureSuggestionId: smartDataCaptureSuggestionId
    }),
    onOpenChange: onOpenChange,
    open: open,
    inlineSize: "360px",
    closeOnTargetLeave: true,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
}